import { ENV_VARS_PROP_NAME } from '../constants/env-var-prop-name.constant';

import { isDefined } from './is-defined.util';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const getEnvVars = <R>(): R => {
  if (typeof process !== 'undefined' && isDefined(process)) {
    return process.env as R;
  }

  const globalEnvVars = globalThis[ENV_VARS_PROP_NAME];

  if (
    isDefined(globalThis) &&
    globalEnvVars &&
    typeof globalEnvVars === 'object' &&
    Object.keys(globalEnvVars).length
  ) {
    return globalEnvVars as R;
  }

  throw new Error('Environment variables are not set.');
};
